import {gql} from '@apollo/client'

export const GET_SERVICES = gql`
  query GetServices(
    $accountId: ID
    $q: String
    $status: String
    $page: Int
    $limit: Int
    $sortBy: String
    $sortDirection: String
  ) {
    services(
      accountId: $accountId
      q: $q
      status: $status
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      collection {
        id
        address
        status
        description
        coords
        numOfMatches
        plan {
          id
          name
          color
        }
        account {
          id
          name
          displayName @client
          contactFullName @client
          contactFirstName
          contactLastName
        }
      }
      metadata {
        totalCount
      }
    }
  }
`
